import { LinearProgress } from '@mui/material';
import { useLoading } from 'react-admin';

export const LoadingIndicator: React.FC = () => {
  const loading = useLoading();

  return <>{loading && <LinearProgress sx={{ zIndex: 500 }} />}</>;
};
